export default "__VITE_ASSET__b78e5783__"